export default function LaunchSection() {
  return (
    <section id="launch" className="py-20 lg:py-32 bg-gradient-to-b from-gray-950 to-black">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">Fast Launch · Nashville, TN</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 sm:mb-8">
            Fast Website Launch for Nashville Businesses
          </h2>
          <div className="space-y-5 sm:space-y-6 text-base sm:text-lg text-gray-400 leading-relaxed max-w-3xl mx-auto">
            <p>
              Because our Nashville websites are built using AI-powered design systems and proven processes, we can deliver a finished website significantly faster than traditional web agencies.
            </p>
            <p>
              Once your website is completed and approved, it can typically be launched and live in Nashville search results within 24 hours — so your business starts getting found online right away.
            </p>
            <p>
              Nashville small businesses deserve to compete online without waiting months for a website. Our AI-powered process means you go from idea to live website in days, giving you a faster path to new customers.
            </p>
          </div>
          <div className="mt-10 sm:mt-12 flex flex-wrap gap-4 sm:gap-6 justify-center">
            <div className="bg-black border border-white/10 rounded-2xl px-6 sm:px-10 py-5 sm:py-6 text-center flex-1 min-w-[120px] max-w-[160px] sm:max-w-none sm:flex-none">
              <div className="text-2xl sm:text-3xl font-bold text-white mb-1">24 hrs</div>
              <div className="text-xs sm:text-sm text-gray-400">Preview turnaround</div>
            </div>
            <div className="bg-black border border-white/10 rounded-2xl px-6 sm:px-10 py-5 sm:py-6 text-center flex-1 min-w-[120px] max-w-[160px] sm:max-w-none sm:flex-none">
              <div className="text-2xl sm:text-3xl font-bold text-white mb-1">1–2 wks</div>
              <div className="text-xs sm:text-sm text-gray-400">Full launch timeline</div>
            </div>
            <div className="bg-black border border-white/10 rounded-2xl px-6 sm:px-10 py-5 sm:py-6 text-center flex-1 min-w-[120px] max-w-[160px] sm:max-w-none sm:flex-none">
              <div className="text-2xl sm:text-3xl font-bold text-white mb-1">$1,000</div>
              <div className="text-xs sm:text-sm text-gray-400">One-time website build</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
